module.exports = {
  //LIVE
  ServicePath: "http://115.124.123.147:5000",
  //ServicePath: "http://115.124.113.248:5000",
  //ServicePath: "http://api.controla.in",
  //ServicePath: "http://184.154.91.140:5000",
  //ServicePath: "https://server1.controla.in",
  //ServicePath: "https://api.controla.in",

  // Sumandeep Vidyapeeth
  // websiteSetting: {
  //   WebUrl: "http://sumandeepvidyapeethdu.edu.in",
  //   AdmissionWebUrl: "http://admission.sumandeepvidyapeethdu.edu.in",
  //   Logo: "../../../../img/logo.png",
  //   PrintLogo: "../../../../img/sumandeeplogo.png",
  //   ThanksImg: ``,
  //   PaymetnAcknowledgement: "Sumandeep Vidyapeeth Payment Acknowledgement",
  //   SignUpMsgModal: `<strong>Mobile is Already Registered</strong><span>Your login credentials has been sent on your registered mobile and email.<br/>To proceed with admission process login with the credentials received</span> <center>
  //     <a href="http://admission.sumandeepvidyapeethdu.edu.in/Login" >
  //       <button
  //         type="button"
  //         class="btn btn-danger btn-lg theme-btn"
  //       >
  //       <i class="fa fa-key" aria-hidden="true"></i>
  //         Login here..
  //       </button>
  //     </a>
  //   </center>`,
  //   NewSignUpMsgModal: `<strong>Thank you for showing interest with us!!!.</strong> <span>Your login credentials has been sent on your registered mobile and email.<br/>To proceed with admission process login with the credentials received</span> <center>
  //   <a href="http://admission.sumandeepvidyapeethdu.edu.in/Login" >
  //     <button
  //       type="button"
  //       class="btn btn-danger btn-lg theme-btn"
  //     >
  //     <i class="fa fa-key" aria-hidden="true"></i>
  //       Login here..
  //     </button>
  //   </a>
  // </center>`,
  //   SignUpSmsTxt: "Thank you for SignUp. Your credentials are <br/>",
  //   EnquiryMsgModal: `<strong>Thank you for Enquiry.</strong><span> Thank you for Enquiry. <br /> Our team will get back to you shortly.</span>`,
  //   EmailHeaderContent: `<br/><br/>Thank you for showing interest for admission in Sumandeep Vidyapeeth.<br/><br/>
  //     For logging in to your Sumandeep Vidyapeeth account to fill the application form, please click on
  //     <a href="http://admission.sumandeepvidyapeethdu.edu.in/Login" target="_blank">http://admission.sumandeepvidyapeethdu.edu.in/Login </a>`,
  //   EmailFooterContent: `<br/><br/>Meanwhile, please visit  <a href="http://sumandeepvidyapeethdu.edu.in" target="_blank">www.sumandeepvidyapeethdu.edu.in</a> for more details. For any clarification, <br/><br/>
  //       feel free to contact us on:- <br/> Phone- +91 8980801285 or <br/>
  //       Email:- <a href="mailto:admission@sumandeepvidyapeethdu.edu.in" target="_top">admission@sumandeepvidyapeethdu.edu.in</a> <br/><br/> Thanking you. <br/><br/>
  //       Admission Cell<br/> Sumandeep Vidyapeeth`,
  //   signUpContent: "sud",
  //   Signupintroduction: ``,
  //   EnquiryContent: `<div class="regformLeftBg bgSuman">
  //       <h3>Admission (2019-20)</h3>
  //       <div class="onlineNote">
  //         <ul>
  //           <li>
  //             <p class="mb-1">
  //               Smt. B.K. Shah Medical Institute and Research Centre
  //               <br />
  //               (M.B.B.S./M.D./M.S./D.M./M.Ch./M.Sc.(medical)/Ph.D.)
  //             </p>
  //           </li>
  //           <li>
  //             <p class="mb-1">
  //               K.M.Shah Dental College and Hospital
  //               <br />
  //               (B.D.S./M.D.S./Dental Mechanics/Ph.D.)
  //             </p>
  //           </li>
  //           <li>
  //             <p class="mb-1">
  //               College of Physiotherapy
  //               <br />
  //               (B.P.T./M.P.T./Ph.D.)
  //             </p>
  //           </li>
  //           <li>
  //             <p class="mb-1">
  //               Department of Pharmacy
  //               <br />
  //               (B. Pharm/Pharm D/Pharm D(PB)/M. Pharm/Ph.D.)
  //             </p>
  //           </li>
  //           <li>
  //             <p class="mb-1">
  //               Sumandeep Nursing College
  //               <br />
  //               (B.Sc.(N)/P.B.B.Sc.(N)/M.Sc.(N)/N.P.C.C./A.N.M./G.N.M./
  //               Ph.D.)
  //             </p>
  //           </li>
  //           <li>
  //             <p class="mb-1">
  //               Department of Management
  //               <br />
  //               (M.P.H./M.B.A.- Health Care (full time)/ M.B.A.- Health
  //               Care (part time)/ Ph.D.)
  //             </p>
  //           </li>
  //           <li>
  //             <p class="mb-1">
  //               Faculty of Paramedical Sciences
  //               <br />
  //               B.Sc./M.Sc./Diploma
  //             </p>
  //           </li>
  //         </ul>
  //       </div>
  //       <center>
  //         <a href="http://sumandeepvidyapeethdu.edu.in" target="_blank">
  //           <button
  //             type="button"
  //             class="btn btn-danger btn-lg theme-btn"
  //           >
  //             <i class="fa fa-globe"></i>
  //             Go to Website
  //           </button>
  //         </a>
  //       </center>
  //     </div>`
  // },

  // Navrachana University
  websiteSetting: {
    WebUrl: "http://nuv.ac.in",
    AdmissionWebUrl: "https://admission.nuv.ac.in",
    Logo: "../../../../img/nuv_logo.png",
    PrintLogo: "../../../../img/nuv_header.png",
    ThanksImg: ``,
    PaymetnAcknowledgement: "Navrachana University Payment Acknowledgement",
    SignUpMsgModal: `<strong>Mobile is Already Registered</strong><span>Your login credentials has been sent on your registered mobile and email.<br/>To proceed with admission process login with the credentials received</span> <center>
      <a href="https://admission.nuv.ac.in/Login" >
        <button
          type="button"
          class="btn btn-danger btn-lg theme-btn"
        >
        <i class="fa fa-key" aria-hidden="true"></i>
          Login here..
        </button>
      </a>
    </center>`,
    NewSignUpMsgModal: `<strong>Thank you for showing interest with us!!!.</strong> <span>Your login credentials has been sent on your registered mobile and email.<br/>To proceed with admission process login with the credentials received</span> <center>
    <a href="https://admission.nuv.ac.in/Login" >
      <button
        type="button"
        class="btn btn-danger btn-lg theme-btn"
      >
      <i class="fa fa-key" aria-hidden="true"></i>
        Login here..
      </button>
    </a>
  </center>`,
    SignUpSmsTxt: "Thank you for SignUp. Your credentials are <br/>",
    EnquiryMsgModal: `<strong>Thank you for Enquiry.</strong><span> Thank you for Enquiry. <br /> Our team will get back to you shortly.</span>`,
    EmailHeaderContent: `<br/><br/>Thank you for showing interest for admission in Navrachana University.<br/>
      For logging in to your Navrachana University account to fill the application form, please click on
      <a href="https://admission.nuv.ac.in/Login" target="_blank">https://admission.nuv.ac.in/Login</a>`,
    EmailFooterContent: `Thanking you.<br/><br/>`,
    signUpContent: "nvu",

    LoginContent: `<div class="regformLeftBg bgNuv">
      <h3 class="mb-3">Contact Details</h3>
      <p class="mb-2"><b>Days :</b> Monday To Friday</p>
      <p class="mb-2"><b>Time :</b> 9:00AM To 5:00PM</p>
      <p class="mb-2"><b>Contact Email</b> : admission@nuv.ac.in</p>
      <p class="mb-2"><b>Contact Number</b> : (0265) 2617285 - 89 </p>
      <p class="mb-2"><b>Mobile Number</b> : 9737071700, 701 </p>
    </div>`,

    Signupintroduction: ``,

    EnquiryContent: `<div class="regformLeftBg bgNuv ">
         <h3 class="text-center">Admission (2019-20)</h3>
         <p>
           <b>Application fee: </b>
           <br />
           All Program: Rs.1000/- <br />
           For BArch Program: Rs.350/-
         </p>
         <p class="mb-1">
           <b>BTech Program:</b>
           <br /> Candidates must register in ACPC. Admission to 75%
           seats (Gujarat Seats) of the Program will be through ACPC
           (Admission Committee for Professional Courses), Government of
           Gujarat on basis of the merit list prepared by the ACPC. The
           remaining 25% seats (All out-of-the-state applications) will
           be filled from the all India candidates (including Gujarat) on
           the basis of percentile score in JEE (Main) examination.
         </p>
         <p class="mb-1">
           <b>BArch Program:</b>
           <br /> Candidates must register in ACPC. Admission to 30 Open
           Seats of the program will take place through the ACPC
           (Admission Committee for Professional Courses) of the
           Government of Gujarat. Admission to 10 Management and NRI/NRI
           sponsored seats are offered by the Navrachana University as
           per the guidelines of ACPC.
         </p>
         <p class="mb-1">
           <b>MBA Program:</b>
           <br /> Candidates must register in ACPC. Admission to 60 seats
           of the Program will be through ACPC (Admission Committee for
           Professional Courses), Government of Gujarat on basis of the
           merit list prepared by the ACPC.
         </p>
         <p class="mb-1">
           <b>All other Programs:</b> Candidates are required to appear
           for entrance exam and/or interview on the basis of eligibility
           criteria decided by the program.
         </p>
         <div class="onlineNote">
           <p class="mb-1">
             <strong>Note:</strong>
           </p>
           <ul>
             <li>
               <p class="mb-1">
                 Candidates are required to fill the name as it appears
                 in the qualifying examination mark sheet.
               </p>
             </li>
             <li>
               <p class="mb-1">
                 Please mention your correct mobile no and email ID for
                 any future communication.
               </p>
             </li>
           </ul>
         </div>
         <center>
           <a href="http://nuv.ac.in" target="_blank">
             <button
               type="button"
               class="btn btn-danger btn-lg theme-btn"
             >
               <i class="fa fa-globe"></i>
               Go to Website
             </button>
           </a>
         </center>
       </div>`
  },

  //UAT
  // ServicePath: "http://192.168.100.111:5000",

  // authorizedURL: "http://academicerp.in"a
  authorizedURL: "http://localhost:3001"
  //ServicePath: "http://localhost:27234"
};



// WEBPACK FOOTER //
// ./src/config/prod.js